import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import html2canvas from 'html2canvas';
@Component({
  selector: 'app-reciept',
  templateUrl: './reciept.component.html',
  styleUrls: ['./reciept.component.scss']
})
export class RecieptComponent implements OnInit, OnChanges {
  orderId: any;
  constructor() { }
  ngOnChanges(changes: SimpleChanges): void {
    console.log(changes);
    if (changes.action && changes.action.currentValue === 'print') {
      this.downloadImage();
    }
  }
  @Input() data: any;
  @Input() action: any;
  @Output() actionResult = new EventEmitter();
  ngOnInit(): void {
    // console.log(typeof(this.data.tip));
  }
  totalBeforeTax() {
    let total = 0;
    this.data?.items?.forEach((item: any) => {
      total += item.price;
    })
    return total;
  }
  // tips() {
  //   var total = this.grandTotal();
  //   var tips=0
  //   if(this.data.tip){
  //     tips=this.data.tip
  //   }else{
  //     tips = total - (this.totalBeforeTax() + this.data.tax);
  //     if(tips<0){
  //       tips=0;
  //     }
  //   }
   
  //   return tips;
  // }
  grandTotal() {
    var total = 0;
    this.data?.payments?.forEach((item: any) => {
      total += item.amount;
    })
    if(!this.data.payments || this.data.payments.length==0){
      total = this.data.total + (this.data.tip?this.data.tip:0);
    }
    return total;
  }
  downloadImage() {
    var element = document.getElementById('receipt');
    html2canvas(element, {}).then((canvas) => {
      var img = canvas.toDataURL("image/png");
      var link = document.createElement('a');
      link.download = `receipt_${this.data?.restaurantName}_${this.data?.orderId}_${new Date().toString()}.png`;
      link.href = img;
      link.click();
    });
  }

}


